import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IonCol, IonContent, IonGrid, IonRow } from '@ionic/angular/standalone';

import { AvatarImageComponent } from '../../../components/avatar-image/avatar-image.component';
import { HeaderComponent } from '../../../components/header/header.component';
import { CurrencyCustomPipe } from '../../../pipes/currency-custom/currency-custom.pipe';
import { JOB_TYPES } from '../../../types/enums';
import { ProfileCardComponent } from './profile-card/profile-card.component';

export type CardTypes =
    | 'rating'
    | 'posted_jobs'
    | 'confirmed_jobs'
    | 'attendance_rate'
    | 'call_offs_rate'
    | 'pay_per_hour'
    | 'job_type';

@Component({
    selector: 'lib-user-profile',
    imports: [
        CommonModule,
        IonCol,
        IonContent,
        IonGrid,
        IonRow,
        AvatarImageComponent,
        HeaderComponent,
        ProfileCardComponent,
        CurrencyCustomPipe
    ],
    templateUrl: './user-profile.component.html',
    styleUrl: './user-profile.component.css'
})
export class UserProfileComponent {
    /* eslint-disable */
    @Input() title: string = '';
    @Input() headerType: 'default' | 'user-profile' = 'default';
    @Input() avatarImage: string | null | undefined = null;
    @Input() backButtonUrl: string = '';

    @Input() headerBackgroundColor: string = 'var(--ion-color-orange)';
    @Input() headerContentColor: string = 'var(--ion-color-dark-0)';
    @Input() avatarBorderColor: string = 'var(--ion-color-dark-0)';

    @Input() cards: Array<{
        type: CardTypes;
        value?: JOB_TYPES.ONE_TIME | JOB_TYPES.ONGOING | any;
        size?: string | undefined;
    }> = [];

    @Output() onSettingsButtonClick = new EventEmitter();

    readonly JOB_TYPES = JOB_TYPES;

    onSettingsClick() {
        this.onSettingsButtonClick.emit();
    }
}
